import { getBackgroundColor, getBorderColor, getOutlineColor, } from '../../colors/colors.alias';
import { getBorderRadius, getBorderWidth, getBorderStyle, getOutlineOffset, getOutlineStyle, getOutlineWidth, } from '../../borders/borders.alias';
import { getBoxShadow } from '../../shadows/shadows.alias';
import { VARIANT_DEFAULT, VARIANT_ATTENTIONAL, VARIANT_TINTED, ELEMENT_CONTAINER, DATA_STATE_SELECTED, INTERACTION_STATE_ACTIVE, INTERACTION_STATE_FOCUS_VISIBLE, INTERACTION_STATE_HOVER, } from '../../constants';
export const constants = Object.freeze({
    NAME: 'Card',
    variants: {
        VARIANT_DEFAULT,
        VARIANT_ATTENTIONAL,
        VARIANT_TINTED,
    },
    elements: {
        ELEMENT_CONTAINER,
    },
    dataStates: {
        DATA_STATE_SELECTED,
    },
    interactionStates: {
        INTERACTION_STATE_ACTIVE,
        INTERACTION_STATE_HOVER,
        INTERACTION_STATE_FOCUS_VISIBLE,
    },
});
export default function getCard(transformer, config) {
    const borderStyle = getBorderStyle(transformer, config);
    const borderColor = getBorderColor(transformer, config);
    const borderWidth = getBorderWidth(transformer, config);
    const backgroundColor = getBackgroundColor(transformer, config);
    const outlineOffset = getOutlineOffset(transformer, config);
    const outlineWidth = getOutlineWidth(transformer, config);
    const outlineColor = getOutlineColor(transformer, config);
    const outlineStyle = getOutlineStyle(transformer, config);
    const borderRadius = getBorderRadius(transformer, config);
    const boxShadow = getBoxShadow(transformer, config);
    return Object.freeze({
        constants,
        interactionStates: {
            [INTERACTION_STATE_ACTIVE]: {
                elements: {
                    [ELEMENT_CONTAINER]: {
                        styles: {
                            backgroundColor: backgroundColor.contentContainer.plain.interactionStates[INTERACTION_STATE_ACTIVE].value,
                        },
                    },
                },
            },
            [INTERACTION_STATE_FOCUS_VISIBLE]: {
                elements: {
                    [ELEMENT_CONTAINER]: {
                        styles: {
                            outlineOffset: outlineOffset.default.value,
                            outlineStyle: outlineStyle.default.value,
                            outlineWidth: outlineWidth.default.value,
                            outlineColor: outlineColor.default.interactionStates[INTERACTION_STATE_FOCUS_VISIBLE].value,
                        },
                    },
                },
            },
        },
        variants: {
            [VARIANT_DEFAULT]: {
                styles: {
                    backgroundColor: backgroundColor.contentContainer.plain.default.value,
                    borderRadius: borderRadius.containerWithBorder.value,
                    borderWidth: borderWidth.container.default.value,
                    borderColor: borderColor.contentContainer.default.value,
                    borderStyle: borderStyle.containerWithBorder.value,
                },
                dataStates: {
                    [DATA_STATE_SELECTED]: {
                        styles: {
                            borderWidth: borderWidth.container.dataStates[DATA_STATE_SELECTED].value,
                            borderColor: borderColor.button.plain.withBorder.dataStates[DATA_STATE_SELECTED].value,
                            backgroundColor: backgroundColor.button.plain.withBorder.dataStates[DATA_STATE_SELECTED].value,
                        },
                    },
                },
            },
            [VARIANT_ATTENTIONAL]: {
                styles: {
                    boxShadow: boxShadow.container.value,
                    backgroundColor: backgroundColor.contentContainer.plain.default.value,
                    borderRadius: borderRadius.containerWithShadow.value,
                },
            },
            [VARIANT_TINTED]: {
                styles: {
                    backgroundColor: backgroundColor.contentContainer.tinted.value,
                    borderRadius: borderRadius.containerWithBackgroundColor.value,
                    borderWidth: borderWidth.contentContainer.tinted.value,
                    borderColor: borderColor.contentContainer.tinted.value,
                    borderStyle: borderStyle.containerWithBorder.value,
                },
            },
        },
    });
}
